export default "__VITE_PUBLIC_ASSET__57b734df__"